import { render } from "./Dragable.vue?vue&type=template&id=2179ff5a"
import script from "./Dragable.vue?vue&type=script&lang=ts"
export * from "./Dragable.vue?vue&type=script&lang=ts"

import "./Dragable.vue?vue&type=style&index=0&id=2179ff5a&lang=less"
script.render = render

export default script